"use client";
import { CommunityCreateModal } from "~/components/v3/community-components/CommunityCreateModal";
import { Button } from "~/components/v4/themed/Button";
import { useLaunchCommunity } from "~/hooks/useLaunchCommunity";

const SwirillyArrowUp = ({ className }: { className?: string }) => {
    return (
        <svg
            className={className}
            width="141"
            height="88"
            viewBox="0 0 141 88"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M50.1603 13.0245C73.3139 -3.62399 105.782 11.2736 108.268 39.6869L108.328 40.3723C101.378 40.4066 94.4087 42.4738 88.3604 46.6357L86.3492 48.0197C84.8956 49.02 83.5364 50.1511 82.2888 51.399L77.4061 56.2828C69.8763 63.8143 70.1689 76.1126 78.0484 83.2773C83.1234 87.892 90.4821 88.9845 96.6784 86.0433L99.8822 84.5224C104.825 82.1764 108.657 77.9946 110.564 72.8662L111.435 70.525C114.215 63.0503 115.415 55.0867 114.966 47.137C119.798 48.2186 124.398 50.5244 128.275 54.0223L135.073 60.1566C136.313 61.2759 138.226 61.1775 139.345 59.9368C140.464 58.696 140.366 56.7828 139.126 55.6635L132.327 49.5292C127.165 44.8713 120.938 41.9674 114.445 40.8701L114.295 39.1592C111.4 6.07212 73.5911 -11.2759 46.6289 8.11112C36.9724 15.0546 28.7352 23.7841 22.3628 33.8278L17.327 41.7648L7.3028 63.5614C6.60461 65.0795 7.26903 66.8762 8.78679 67.5746C10.3046 68.2729 12.1009 67.6083 12.7991 66.0902L22.6532 44.6635L27.4709 37.0702C33.4293 27.6792 41.1312 19.5168 50.1603 13.0245ZM108.855 46.4252C109.43 53.8904 108.376 61.3937 105.765 68.4151L104.894 70.7563C103.536 74.4077 100.807 77.3852 97.2884 79.0556L94.0845 80.5764C90.1045 82.4656 85.3778 81.7639 82.118 78.7998C76.7944 73.9591 76.5967 65.6501 81.6841 60.5617L86.5667 55.6779C87.5535 54.6909 88.6285 53.7963 89.7782 53.0051L91.7894 51.6212C96.9523 48.0685 102.924 46.3552 108.855 46.4252Z"
                fill="#D1E350"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.35422 39.8593C0.740463 40.2916 -0.217331 41.9506 0.214928 43.5647L6.41148 66.7037C7.06487 69.1435 9.83348 70.3233 12.0452 69.1043L32.2535 57.9666C33.7167 57.1602 34.2493 55.32 33.443 53.8565C32.6368 52.3929 30.797 51.8603 29.3338 52.6667L11.5416 62.4727L6.05883 41.9991C5.62658 40.3849 3.96796 39.4269 2.35422 39.8593Z"
                fill="#D1E350"
            />
        </svg>
    );
};

const ArrowDownUp = ({ className }: { className?: string }) => {
    return (
        <svg
            className={className}
            width="134"
            height="97"
            viewBox="0 0 134 97"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.37543 38.7561C4.52049 50.2655 7.78331 62.4334 16.013 70.9679C29.5272 84.9824 48.6938 92.0691 68.0753 90.2174L72.2172 89.8217C92.2009 87.9124 111.31 80.6869 127.56 68.8956L128.68 68.0827C129.953 67.1586 131.735 67.4418 132.658 68.7152C133.582 69.9886 133.298 71.7698 132.025 72.6938L130.904 73.5069C113.831 85.8956 93.7541 93.4872 72.7579 95.4932L68.616 95.8889C47.5066 97.9058 26.6312 90.1873 11.9123 74.9233C2.32175 64.9777 -1.4806 50.7977 1.84642 37.3852L2.78469 33.6027C5.30596 23.4384 11.1353 14.4008 19.3549 7.91241L24.4446 3.89478L27.9734 8.36676L22.8838 12.3844C15.6563 18.0896 10.5306 26.0363 8.3137 34.9736L7.37543 38.7561Z"
                fill="#C9E9E9"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.79048 3.19276C1.92013 1.6248 3.29613 0.458614 4.86386 0.588002L27.3379 2.44285C29.7076 2.63844 31.2651 5.0057 30.5071 7.25993L23.5818 27.8562C23.0803 29.3475 21.4651 30.1501 19.9741 29.6489C18.4831 29.1477 17.6809 27.5324 18.1823 26.0411L24.2797 7.90728L4.39434 6.26608C2.82661 6.13669 1.66082 4.76072 1.79048 3.19276Z"
                fill="#C9E9E9"
            />
        </svg>
    );
};

const GreenAsterisk = ({ className }: { className?: string }) => {
    return (
        <svg
            className={className}
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M17.9079 0.0550329L24.472 2.64404L18.1356 13.8576L30.5295 10.0843L31.603 16.8764L18.6125 16.6972L28.3401 25.5866L23.1388 29.8231L16.3271 18.5587L13.8714 31.319L7.43892 28.8918L13.7224 17.4522L1.38148 21.4515L0.176268 14.4977L13.1667 14.6768L3.51798 5.72325L8.71926 1.48675L15.3863 12.7345L17.9079 0.0550329Z"
                fill="#198922"
            />
        </svg>
    );
};

const PurpleAsterisk = ({ className }: { className?: string }) => {
    return (
        <svg
            className={className}
            width="44"
            height="45"
            viewBox="0 0 44 45"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M40.4471 10.3497L43.8128 19.4881L26.3543 23.19L41.6848 32.5341L35.6358 39.8449L23.8513 26.2754L23.6034 44.4323L14.4207 42.9338L19.8165 25.617L4.33102 34.7361L0.919013 25.8813L18.5629 21.9185L3.0471 12.8354L9.14234 5.24094L20.9268 18.8104L21.3138 0.676216L30.4966 2.17479L24.9848 19.3271L40.4471 10.3497Z"
                fill="#CEBDF1"
            />
        </svg>
    );
};

const MeetLikeMindedPeople = () => {
    const { isCommunityCreateVisible, setCreateCommunityVisible } =
        useLaunchCommunity();

    return (
        <>
            <div className="hidden md:block">
                <div className="relative flex flex-col items-center justify-center gap-8 pt-14">
                    <h1 className="text-center text-[60px] font-[500] leading-normal text-white">
                        Meet like-minded people near you
                    </h1>
                    <p className="max-w-[900px] text-center text-[32px] leading-9">
                        Discover community events, meet like-minded people, and
                        grow your local IRL network.
                    </p>

                    {/* <Button onClick={() => setCreateCommunityVisible(true)}>
                        Launch your community
                    </Button> */}

                    <SwirillyArrowUp className="absolute -top-10 right-[15%]" />
                    <ArrowDownUp className="absolute -bottom-16 left-6" />
                    <GreenAsterisk className="absolute left-[13%] top-2" />
                    <PurpleAsterisk className="absolute -bottom-5 right-[5%]" />
                </div>
            </div>

            <div className="md:hidden">
                <div className="relative flex flex-col items-center justify-center gap-3">
                    <h1 className="text-center text-[22px] font-[500] leading-normal text-white md:text-[32px]">
                        Meet like-minded people near you
                    </h1>

                    <p className="max-w-[900px] text-center text-[16px] md:text-[18px] md:leading-9">
                        Discover community events, meet like-minded people, and
                        grow your local IRL network.
                    </p>

                    <SwirillyArrowUp className="absolute -right-28 -top-20" />
                    <ArrowDownUp className="absolute -bottom-20 -left-8 hidden scale-75 sm:block" />
                </div>
            </div>

            <CommunityCreateModal
                isVisible={isCommunityCreateVisible}
                setVisible={(visible, routing) => {
                    setCreateCommunityVisible(visible, routing);
                }}
            />
        </>
    );
};

export default MeetLikeMindedPeople;
